"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RelatedArticlesSlider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CustomCursor = _interopRequireDefault(require("../../../CustomCursor"));
var _useIsMobileViewport = require("../../../../helpers/hooks/use-is-mobile-viewport");
var _useMouseTracker2 = require("../../../../helpers/hooks/use-mouse-tracker");
var _useSlider2 = require("../../../../helpers/hooks/use-slider");
var _classNameBuilder = _interopRequireDefault(require("../../../../helpers/styles/class-name-builder"));
var _RelatedArticlesCard = _interopRequireDefault(require("../RelatedArticlesCard"));
var _styles = require("./styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var DefaultBaseBullet = function DefaultBaseBullet() {
  return /*#__PURE__*/_react.default.createElement("span", null, "\u25E6");
};
var DefaultActiveBullet = function DefaultActiveBullet() {
  return /*#__PURE__*/_react.default.createElement("span", null, "\u2022");
};
var RelatedArticlesSlider = function RelatedArticlesSlider(_ref) {
  var relatedArticles = _ref.relatedArticles,
    _ref$showBullets = _ref.showBullets,
    showBullets = _ref$showBullets === void 0 ? true : _ref$showBullets,
    _ref$activeBulletCont = _ref.activeBulletContent,
    activeBulletContent = _ref$activeBulletCont === void 0 ? /*#__PURE__*/_react.default.createElement(DefaultActiveBullet, null) : _ref$activeBulletCont,
    _ref$baseBulletConten = _ref.baseBulletContent,
    baseBulletContent = _ref$baseBulletConten === void 0 ? /*#__PURE__*/_react.default.createElement(DefaultBaseBullet, null) : _ref$baseBulletConten,
    _ref$isBulletClickabl = _ref.isBulletClickable,
    isBulletClickable = _ref$isBulletClickabl === void 0 ? true : _ref$isBulletClickabl,
    overrideSlideContent = _ref.overrideSlideContent,
    customCursor = _ref.customCursor,
    locale = _ref.locale,
    showIndex = _ref.showIndex,
    onScrollSettled = _ref.onScrollSettled,
    targetIndex = _ref.activeSlideIndex;
  var _useSlider = (0, _useSlider2.useSlider)(locale !== null && locale !== void 0 ? locale : "en-us", {
      align: "start"
    }),
    sliderRef = _useSlider.sliderRef,
    _useSlider$data = _useSlider.data,
    activeSlideIndex = _useSlider$data.activeSlideIndex,
    scrollSnaps = _useSlider$data.scrollSnaps,
    goTo = _useSlider.actions.goTo,
    emblaAPI = _useSlider.emblaAPI;
  var _useMouseTracker = (0, _useMouseTracker2.useMouseTracker)(),
    mouseTrackerRef = _useMouseTracker.targetRef,
    _useMouseTracker$data = _useMouseTracker.data,
    mousePosition = _useMouseTracker$data.mousePosition,
    isMouseIn = _useMouseTracker$data.isMouseIn;
  var isMobile = (0, _useIsMobileViewport.useIsMobileViewport)();
  (0, _react.useMemo)(function () {
    return emblaAPI === null || emblaAPI === void 0 ? void 0 : emblaAPI.on("settle", function () {
      return onScrollSettled === null || onScrollSettled === void 0 ? void 0 : onScrollSettled.call(undefined, emblaAPI.selectedScrollSnap());
    });
  }, [emblaAPI, onScrollSettled]);
  (0, _react.useEffect)(function () {
    if (typeof targetIndex !== "number") {
      return;
    }
    goTo(targetIndex);
  }, [targetIndex, goTo]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "related-article-slide-wrapper",
    ref: mouseTrackerRef
  }, /*#__PURE__*/_react.default.createElement(_styles.ArticleSlideWrapper, {
    className: "article-slide",
    ref: sliderRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "article-slide-content"
  }, relatedArticles.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "article-slide-card",
      key: item.id
    }, overrideSlideContent ? overrideSlideContent.call(null, item) : /*#__PURE__*/_react.default.createElement(_RelatedArticlesCard.default, _extends({
      item: item,
      testId: "related-articles:card-".concat(index)
    }, showIndex ? {
      index: "0".concat(index + 1)
    } : {})));
  }))), showBullets && /*#__PURE__*/_react.default.createElement(_styles.ArticleSliderBulletWrapper, {
    className: "bullet-list-wrapper"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "bullet-list"
  }, scrollSnaps.map(function (_ref2, i) {
    _objectDestructuringEmpty(_ref2);
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i,
      className: (0, _classNameBuilder.default)("bullet", {
        "active-bullet": activeSlideIndex === i,
        "bullet-clickable": isBulletClickable
      }),
      onClick: function onClick() {
        return goTo(i);
      }
    }, activeSlideIndex === i ? activeBulletContent : baseBulletContent);
  }))), isMouseIn && !isMobile && customCursor && /*#__PURE__*/_react.default.createElement(_CustomCursor.default, {
    startPosition: mousePosition,
    customIcon: customCursor
  }));
};
exports.RelatedArticlesSlider = RelatedArticlesSlider;
var _default = (0, _styledComponents.default)(RelatedArticlesSlider).withConfig({
  displayName: "RelatedArticlesSlider",
  componentId: "sc-11qzj4b-0"
})([""]);
exports.default = _default;